export class BatchCreate<T> {
	constructor(public data: T) {}
}
